module.exports = __webpack_public_path__ + "files/93ebdb6f836e93eb7439927ae04e2057.png";